import type { PortalAudience } from '@/access/portalAccess.types';
import { FeatureFlag, isFeatureEnabled } from '@/utils/featureFlags';
import type { ClientsViewInput } from '@/modules/clients/clients.viewInput';

export type ClientDetailTabKey =
  | 'details'
  | 'sites'
  | 'activity'
  | 'jobs'
  | 'candidates'
  | 'billing'
  | 'rates'
  | 'users'
  | 'documents';

type ClientDetailTabDefinition = {
  key: ClientDetailTabKey;
  label: string;
  featureFlag?: FeatureFlag;
};

const TENANT_TABS: ClientDetailTabDefinition[] = [
  { key: 'details', label: 'Details' },
  { key: 'sites', label: 'Sites', featureFlag: 'clientSitesTab' },
  { key: 'activity', label: 'Activity' },
  { key: 'jobs', label: 'Jobs' },
  { key: 'candidates', label: 'Candidates' },
  { key: 'billing', label: 'Billing' },
  { key: 'rates', label: 'Rates' },
  { key: 'users', label: 'Users' },
  { key: 'documents', label: 'Documents' },
];

export type ClientDetailView = {
  audience: PortalAudience;
  tabs: ClientDetailTabKey[];
  actions: {
    showLogoUpdate: boolean;
    showUpdateClient: boolean;
  };
  query: {
    client: { fetch: boolean };
  };
};

export const getClientDetailTabs = (
  tabKeys: ClientDetailTabKey[],
): { key: ClientDetailTabKey; label: string }[] =>
  TENANT_TABS.filter((tab) => tabKeys.includes(tab.key)).map((tab) => ({
    key: tab.key,
    label: tab.label,
  }));

export const getClientDetailView = ({
  access,
}: ClientsViewInput): ClientDetailView => {
  const { audience } = access;

  const tabs = TENANT_TABS.filter(
    (tab) => !tab.featureFlag || isFeatureEnabled(tab.featureFlag),
  ).map((tab) => tab.key);

  return {
    audience,
    tabs,
    actions: {
      showLogoUpdate: true,
      showUpdateClient: true,
    },
    query: {
      client: { fetch: true },
    },
  };
};
